/**
 * Turns a bulk add's `{ status: "failed" }` answer into a rejection (PREC-4497).
 *
 * `PATCH list/bulkAddToTracker` and `bulkAddCompanyToTracker` used to answer a failure with 200 and
 * that body, and every caller awaited only the status, so a failed add closed its picker exactly
 * like a successful one. The API now answers a failure with an error status; this keeps a caller
 * right against an API that still answers the old way (a deploy window, an older instance).
 */
export const assertBulkAddSucceeded = <T extends { status?: string } | undefined>(result: T): T => {
	if (result?.status === "failed") {
		// No message of its own: the caller's failure text is what the user reads.
		throw new Error("");
	}

	return result;
};
